// extracted by css-extract-rspack-plugin
export default {"autoplayed":"VideoHosted-module__autoplayed__agnfv"};